import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'
//import api from "./api/api.js";


Vue.config.productionTip = false
Vue.use(Buefy);
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    services: null,
    modes: null,
    languages: null,
    cities: null,
    friends: null,
    seriesStatuses: null,
    authenticated: false
  },
  mutations : {
  /*  initServices: (state, payload) => {
      
      state.services = payload.data
    },
    initModes: (state, payload) => {
      state.modes = payload.data
    },
    initLanguages: (state, payload) => {
      state.languages = payload.data
    },
    initCities: (state, payload) => {
      state.cities = payload.data
    },
    initFriends: (state, payload) => {
      state.friends = payload.data
    }*/
  },
  actions: {
   /* getServices: ({commit}) => {
      api.service.getAll().then(res=>commit('initServices', res))
    },
    getModes: ({commit}) => {
      api.mode.getAll().then(res=>commit('initModes', res))
    },
    getLanguages: ({commit}) => {
      api.language.getAll().then(res=>commit('initLanguages', res))
    },
    getCities: ({commit}) => {
      api.city.getAll().then(res=>commit('initCities', res))
    },
    getFriends: ({commit}) => {
      api.friend.getAll().then(res=>commit('initFriends', res))
    }*/
  }
})

new Vue({router, store:store,
  render: h => h(App),
}).$mount('#app')

